module.exports = __webpack_public_path__ + "img/plumbing-128x128-transparent.667d86c1.png";